import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { Collapse as AntCollapse } from "antd";

import "antd/es/collapse/style/css";

import styles from "./collapse.css";

import RightArrowIcon from "./RightArrow.svg";
import LeftArrowIcon from "./LeftArrow.svg";
import DownArrowIcon from "./DownArrow.svg";

const { Panel: AntCollapsePanel } = AntCollapse;

/**
 * Use this component to show the content in collapse state
 */
export function Collapse(props) {
  const {
    children,
    onChange,
    className,
    activePanelIndexes = [],
    isCollapse = false
  } = props;
  return (
    <div className={`${styles.collapse} ${className}`}>
      <AntCollapse
        defaultActiveKey={activePanelIndexes}
        onChange={onChange}
        expandIconPosition={window.isRTL ? "left" : "right"}
        accordion={isCollapse}
        expandIcon={(panelProps) => {
          if (!panelProps.isActive) {
            return window.isRTL ? <LeftArrowIcon /> : <RightArrowIcon />;
          }
          return <DownArrowIcon />;
        }}
        {...props}
      >
        {children}
      </AntCollapse>
    </div>
  );
}

Collapse.propTypes = {
  /** Render the children inside the collapse */
  children: PropTypes.node.isRequired,
  /** To styles the accordian  */
  className: PropTypes.string,
  /** OnClick trigger if user select heading */
  onChange: PropTypes.func,
  /** Default active will be used by prop */
  activePanelIndexes: PropTypes.arrayOf(PropTypes.number),
  /** The Collapse will be change as accordian based on this prop */
  isCollapse: PropTypes.bool
};

Collapse.defaultProps = {
  activePanelIndexes: [],
  isCollapse: false
};

// eslint-disable-next-line kf/const-naming-convention
export const CollapsePanel = AntCollapsePanel;
CollapsePanel.displayName = "AccordianPanel";
CollapsePanel.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  activePanelIndexes: PropTypes.arrayOf(PropTypes.number)
};
